import React from 'react';

import { CollectionFieldSchema } from '@candu-ai/collections/types';
import { FieldsEditor } from '@candu-ai/editor-nodes/collection-settings';
import { useCollectionsFromContext } from 'craft/components/SelectedToolbar/Collections/hooks/useCollectionsFromContext';
import { useMultiNodes } from 'craft/hooks';
import { ContentCollection } from 'craft/types';

export interface FieldsEditorProps {
  nodeIds: string[];
  collections: ContentCollection[];
  type: string | undefined;
  collectionEmbedLocations: Record<string, CollectionFieldSchema[]>;
  isPopover?: boolean;
}

export const CollectionFieldsEditor: React.FC<FieldsEditorProps> = ({
  nodeIds,
  collections,
  type,
  collectionEmbedLocations,
  isPopover,
}: FieldsEditorProps) => {
  const collectionIds = useCollectionsFromContext(nodeIds);

  const {
    actions: { setCustom, setProps },
  } = useMultiNodes(nodeIds);

  return (
    <FieldsEditor
      nodeIds={nodeIds}
      collectionId={collectionIds[0]}
      collectionEmbedLocations={collectionEmbedLocations}
      collections={collections}
      type={type}
      setCustom={setCustom}
      setProps={setProps}
      isPopover={isPopover}
    />
  );
};
